var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconCopy = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M19.5 9.2355C19.5 8.06925 18.5558 7.125 17.3903 7.125H10.3583C9.23625 7.125 8.319 8.00025 8.253 9.1065L8.24925 9.23475V18.5138C8.24925 19.6372 9.1245 20.5538 10.23 20.6205L10.3583 20.6243H17.3903C18.5393 20.6243 19.4723 19.707 19.4993 18.564L19.5 9.23475V9.2355ZM17.0813 8.625C17.5898 8.625 18 9.03525 18 9.543V18.2078L17.9948 18.3015C17.9513 18.7335 17.6078 19.077 17.175 19.1205L17.0813 19.125H10.6695C10.1933 19.125 9.8025 18.7643 9.75525 18.3015L9.75 18.2078V9.543C9.75 9.0675 10.1108 8.67675 10.575 8.63025L10.6688 8.62575H17.082L17.0813 8.625Z", fill: "black" }),
            React.createElement("path", { d: "M6.75 15.36V16.875H6.609C5.4435 16.875 4.49925 15.9308 4.49925 14.7645V5.4855C4.49925 4.31925 5.4435 3.375 6.609 3.375H13.6403C14.8058 3.375 15.75 4.31925 15.75 5.4855V5.625H14.235C14.1563 5.19825 13.782 4.875 13.3313 4.875H6.91875C6.41025 4.875 6 5.28525 6 5.793V14.4578C6 14.9078 6.3225 15.2812 6.75 15.36Z", fill: "black" }))),
        alt: 'Icon Copy',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconCopy;
//# sourceMappingURL=index.js.map